import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { get as _get } from 'lodash';
import { connect } from "react-redux";
import Helmet from "react-helmet";
import { Nav, Tab } from "react-bootstrap";

import { SingleDropzone } from "../../resusableComponents/common/formElements";

import { withRouter } from "../../resusableComponents/hoc/withRouter";

import { updateLoadingState } from "../../redux/actions/application";

import LeadScraper from "./components/LeadScraper";
import AuditDashboard from "./components/AuditDashboard";

class AddData extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activeTab: "upload",
    };
  }

  render() {
    const { allowedDataUploadFiles, allowedDataUploadFilesLabel, intl } = this.props;
    const { activeTab } = this.state;

    return (
      <>
        <Helmet>
          <title>
            {intl.formatMessage({ id: "olympus.add_data", defaultMessage: "Add Data: Olympus" })}
          </title>
        </Helmet>

        <div className="content-wrapper">
          <div className="container-fluid flex-grow-1 px-6 py-6">
            <div className="row gy-2">
              <div className="col-lg-12">
                <h1 className="heading-04 fw-semibold text-dark-35 text-uppercase">
                  <FormattedMessage id="addData.title" defaultMessage="Add Data" />
                </h1>
              </div>
            </div>

            <div className="row gy-4 mt-0">
              <div className="col-lg-12">
                <div className="card shadow-none">
                  <div className="card-body">

                    <Tab.Container id="add-data-tabs" activeKey={activeTab} onSelect={(key) => this.setState({ activeTab: key })}>
                      <Nav variant="tabs" className="bg-white-f0 rounded-1 mb-5">
                        <Nav.Item>
                          <Nav.Link eventKey="upload" className="text-capitalize">
                            <FormattedMessage id="addData.tab.upload" defaultMessage="Upload" />
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="scrape" className="text-capitalize">
                            <FormattedMessage id="addData.tab.scrape" defaultMessage="Scrape" />
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="audit" className="text-capitalize">
                            <FormattedMessage id="addData.tab.audit" defaultMessage="Audit Dashboard" />
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>

                      <Tab.Content>
                        <Tab.Pane eventKey="upload">
                          <div className="row">
                            <div className="col-lg-12">
                              <div className="card card-file-upload">
                                <div className="card-body">
                                  <div className="row">
                                    <div className="col-lg-12">
                                      <label className="form-label text-capitalize">
                                        <FormattedMessage id="file.attach_file" defaultMessage="attach file" />
                                      </label>

                                      <SingleDropzone
                                        acceptedFormat={allowedDataUploadFiles}
                                        allowedExtensions={allowedDataUploadFilesLabel}
                                        setState={(args) => this.setState(args)}
                                        source="contact_upload_file"
                                      />

                                      {/*<div className="file-upload-list">
                                        <p>file-name-287654479.csv</p>
                                        <a href="/">Delete</a>
                                      </div>*/}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="scrape">
                          <LeadScraper isActive={activeTab === "scrape"} />
                        </Tab.Pane>
                        <Tab.Pane eventKey="audit">
                          <AuditDashboard isActive={activeTab === "audit"} />
                        </Tab.Pane>
                      </Tab.Content>
                    </Tab.Container>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </>
    );
  }
}

const mapStateToProps = (state) => ({
  allowedDataUploadFiles: _get(state, "application.constants.allowedDataUploadFiles", ""),
  allowedDataUploadFilesLabel: _get(state, "application.constants.allowedDataUploadFilesLabel", ""),
});

const mapDispatchToProps = (dispatch) => ({
  updateLoadingState: (data) => dispatch(updateLoadingState(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(AddData)));
